// extracted by mini-css-extract-plugin
export default {"ContainerPrincipal":"estilo_ContainerPrincipal__UhuZm","titulo":"estilo_titulo__FD4fV"};